<mat-dialog-content>
  <div fxLayout="column" class="div-container" ngClass.xs="div-container-xs" fxLayoutGap="20px">
    <span fxLayout="column" fxLayoutGap="10px">
      <span class="subtitle regular">
        {{'welcome_to' | transloco}}
      </span>
      <img alt="img" src="assets/icons/logo_startup.png" height="28px" width="156px" />
    </span>
    <span fxLayout="column" fxLayoutGap="2px">
      <span class="textLarge medium" ngClass.xs="textsmaller medium">
        {{'app_tour_video' | transloco}}
      </span>
      <span fxLayoutAlign="end end">
        <span class="watch-more" ngClass.xs="watch-more xs" (click)="userGuide()">{{'more_videos' | transloco}} </span>
      </span>
    </span>
    <span *ngIf="!onMobile && !onMobilexs && !onMobilesm" fxLayoutAlign="center center">
      <video title="video" width="640" height="360" controls="controls" tabindex="0" style="border: none;">
        <source
          src="https://sqlva3afz6duaqqo7y.blob.core.windows.net/app-tour/1.Self Check-In Flow for READY Status.mp4"
          type="video/mp4">
      </video>
    </span>
    <span *ngIf="onMobile">
      <video title="video" width="240" height="160" controls="controls" tabindex="0" style="border: none;">
        <source
          src="https://sqlva3afz6duaqqo7y.blob.core.windows.net/app-tour/1.Self Check-In Flow for READY Status.mp4"
          type="video/mp4">
      </video>
    </span>
    <span *ngIf="onMobilexs">
      <video title="video" width="200" height="160" controls="controls" tabindex="0" style="border: none;">
        <source
          src="https://sqlva3afz6duaqqo7y.blob.core.windows.net/app-tour/1.Self Check-In Flow for READY Status.mp4"
          type="video/mp4">
      </video>
    </span>
    <span *ngIf="onMobilesm">
      <video title="video" width="270" height="160" controls="controls" tabindex="0" style="border: none;">
        <source
          src="https://sqlva3afz6duaqqo7y.blob.core.windows.net/app-tour/1.Self Check-In Flow for READY Status.mp4"
          type="video/mp4">
      </video>
    </span>

  </div>
</mat-dialog-content>
<mat-dialog-actions fxLayout="column" fxLayoutAlign="center center">
  <div fxLayout="row" style="padding-bottom: 40px;padding-top: 20px;" ngStyle.xs="padding-top: 0px;" fxLayoutGap="10px">
    <button fxFlexAlign="center" mat-flat-button color="primary" (click)="getStarted()"
      style="border-color: #0014DC !important;border-radius: 24px;">
      {{'get_started' |transloco }}
    </button>
  </div>
</mat-dialog-actions>
